function scrollToEl(el, off){ if(!el) return; window.scrollTo({top: el.getBoundingClientRect().top + window.pageYOffset - (off||0), behavior:'smooth'}); }
var poAllCards = [];
var poCurrent = 1;
var poPer = 50;

function initPreOrder() {
  var grid = document.getElementById('poGrid');
  if (!grid) return;
  var cards = grid.getElementsByClassName('po-card');
  poAllCards = [];
  for (var i = 0; i < cards.length; i++) poAllCards.push(cards[i]);
  poShowPage(poAllCards, 1);
}

function filterPreOrder(q) {
  var grid = document.getElementById('poGrid');
  if (!grid) return;
  var cards = grid.getElementsByClassName('po-card');
  var matched = [];
  q = q.replace(/ /g,'').toLowerCase();
  for (var i = 0; i < cards.length; i++) {
    var num = cards[i].querySelector('.po-num');
    var t = num ? num.textContent.replace(/ /g,'') : '';
    if (!q || t.indexOf(q) > -1) matched.push(cards[i]);
  }
  poShowPage(matched, 1);
}

function poShowPage(cards, page) {
  var total = cards.length;
  var totalPages = Math.max(1, Math.ceil(total / poPer));
  if (page < 1) page = 1;
  if (page > totalPages) page = totalPages;
  poCurrent = page;
  var start = (page-1)*poPer;
  var end = Math.min(start+poPer, total);
  var grid = document.getElementById('poGrid');
  var all = grid.getElementsByClassName('po-card');
  for (var i = 0; i < all.length; i++) all[i].style.display = 'none';
  for (var j = start; j < end; j++) cards[j].style.display = '';
  var from = total===0 ? 0 : start+1;
  var info = 'Showing '+from+'-'+end+' of '+total+' pre-order numbers';
  var t = document.getElementById('poInfoTop');
  var b = document.getElementById('poInfoBottom');
  if (t) t.innerHTML = info;
  if (b) b.innerHTML = info;
  buildPoPg('poPaginationTop', page, totalPages, cards);
  buildPoPg('poPaginationBottom', page, totalPages, cards);
}

function scrollToPreorder() {
  requestAnimationFrame(function() {
    var el = document.getElementById('preorder');
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo(0, top);
  });
}

function buildPoPg(id, page, total, cards) {
  var wrap = document.getElementById(id);
  if (!wrap) return;
  wrap.innerHTML = '';
  var prev = document.createElement('button');
  prev.className = 'pg-btn pg-arrow';
  prev.innerHTML = '&larr;';
  if (page===1) prev.disabled = true;
  prev.onclick = function() { poShowPage(cards, page-1); scrollToPreorder(); };
  wrap.appendChild(prev);
  var nums = getPgNums(page, total);
  for (var i = 0; i < nums.length; i++) {
    var btn = document.createElement('button');
    if (nums[i]==='...') {
      btn.className='pg-btn pg-dots'; btn.innerHTML='&hellip;';
    } else {
      btn.className = nums[i]===page ? 'pg-btn active' : 'pg-btn';
      btn.innerHTML = nums[i];
      (function(pg) { btn.onclick = function() { poShowPage(cards, pg); scrollToPreorder(); }; })(nums[i]);
    }
    wrap.appendChild(btn);
  }
  var nxt = document.createElement('button');
  nxt.className = 'pg-btn pg-arrow';
  nxt.innerHTML = '&rarr;';
  if (page===total) nxt.disabled = true;
  nxt.onclick = function() { poShowPage(cards, page+1); scrollToPreorder(); };
  wrap.appendChild(nxt);
}

function getPgNums(cur,tot) {
  if(tot<=7){ var a=[]; for(var i=1;i<=tot;i++) a.push(i); return a; }
  var p=[1]; if(cur>3) p.push('...');
  var s=cur-1>2?cur-1:2, e=cur+1<tot?cur+1:tot-1;
  for(var i=s;i<=e;i++) p.push(i);
  if(cur<tot-2) p.push('...'); p.push(tot); return p;
}

if (window.addEventListener) {
  window.addEventListener('load', function() { try { initPreOrder(); } catch(e) {} });
}











/* MOBILE NAV */
function toggleMobileNav() {
  var btn = document.getElementById('hamburgerBtn');
  var nav = document.getElementById('mobileNav');
  var overlay = document.getElementById('mobileOverlay');
  if (!btn || !nav || !overlay) return;
  var isOpen = nav.className.indexOf('open') > -1;
  if (isOpen) {
    closeMobileNav();
  } else {
    nav.className = 'mobile-nav open';
    overlay.className = 'mobile-nav-overlay open';
    btn.className = 'hamburger open';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('nav-open');
    var h=document.querySelector('header');if(h)h.style.borderBottomColor='transparent';var ht=document.querySelector('.hero-tag');if(ht)ht.style.visibility='hidden';
  }
}

function closeMobileNav() {
  var btn = document.getElementById('hamburgerBtn');
  var nav = document.getElementById('mobileNav');
  var overlay = document.getElementById('mobileOverlay');
  if (nav) nav.className = 'mobile-nav';
  if (overlay) overlay.className = 'mobile-nav-overlay';
  if (btn) btn.className = 'hamburger';
  document.body.style.overflow = '';
  document.body.classList.remove('nav-open');
  var h=document.querySelector('header');if(h)h.style.borderBottomColor='';var ht=document.querySelector('.hero-tag');if(ht)ht.style.visibility='';
}

/* BACK TO TOP + SCROLL PROGRESS */
if (window.addEventListener) {
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        var bar = document.getElementById('scrollProgress');
        if (bar) bar.style.width = progress + '%';
        var btn = document.getElementById('backToTop');
        if (btn) { btn.className = scrollTop > 400 ? 'visible' : ''; }
        ticking = false;
      });
      ticking = true;
    }
  }, {passive: true});
}



/*  VIP Nav Search  */
function VIPNavToggle() {
  var ov = document.getElementById('navSearchOverlay');
  var inp = document.getElementById('navSearchInput');
  if (!ov) return;
  if (ov.classList.contains('open')) {
    VIPNavClose();
  } else {
    ov.classList.add('open');
    setTimeout(function(){ if(inp) inp.focus(); }, 320);
  }
}
function VIPNavCloseUI() {
  var ov  = document.getElementById('navSearchOverlay');
  var dr  = document.getElementById('navDropdown');
  var inp = document.getElementById('navSearchInput');
  if (ov)  ov.classList.remove('open');
  if (dr)  { dr.classList.remove('open'); dr.innerHTML = ''; }
  if (inp) inp.value = '';
}
function VIPNavClose() {
  var ov  = document.getElementById('navSearchOverlay');
  var dr  = document.getElementById('navDropdown');
  var inp = document.getElementById('navSearchInput');
  if (ov)  ov.classList.remove('open');
  if (dr)  { dr.classList.remove('open'); dr.innerHTML = ''; }
  if (inp) inp.value = '';
  if (typeof activeFilters !== 'undefined') activeFilters.search = '';
  if (typeof applyFilters  === 'function')  applyFilters();
  if (typeof filterPreOrder === 'function') filterPreOrder('');
}
function VIPNavSearch(val) {
  /* v144 (28 Oct 2026): intentionally does nothing. Header number search is handled by
     assets/vip-number-search.js (results panel). The legacy behaviour filtered only the
     cards on the current page and showed "Showing 0-0 of 0 numbers". The function name is
     kept so the oninput handlers in the header sections do not throw errors. */
}
function VIPNavRender(q) {
  var dr = document.getElementById('navDropdown');
  if (!dr) return;
  dr.innerHTML = '';
  if (!q || q.length < 2) { dr.classList.remove('open'); return; }

  /* Main numbers */
  var allCards = document.querySelectorAll('#numGrid .num-card');
  var mMatch = [];
  for (var i = 0; i < allCards.length; i++) {
    if ((allCards[i].getAttribute('data-num') || '').indexOf(q) > -1) mMatch.push(allCards[i]);
  }
  VIPNavRender._gen = (VIPNavRender._gen || 0) + 1;
  var myGen = VIPNavRender._gen;

  var MAX = 8;

  /* VIP Numbers section */
  if (mMatch.length) {
    var t1 = document.createElement('div');
    t1.className = 'nsd-title';
    t1.textContent = 'Available Numbers (' + mMatch.length + ')';
    dr.appendChild(t1);
    var show = Math.min(mMatch.length, MAX);
    for (var m = 0; m < show; m++) {
      var card  = mMatch[m];
      var num   = card.getAttribute('data-num') || '';
      var price = card.getAttribute('data-price') || '';
      var tier  = card.getAttribute('data-tier') || '';
      var fmtN  = num.replace(/(\d{5})(\d{3})(\d{3})/,'$1 $2 $3');
      var tc    = {platinum:'tl-plat',diamond:'tl-diam',gold:'tl-gold',bronze:'tl-brnz'}[tier] || 'tl-silv';
      var row   = document.createElement('div');
      row.className = 'nsd-item';
      var sNum  = document.createElement('span'); sNum.className = 'nsd-num';  sNum.textContent = fmtN;
      var sR    = document.createElement('span'); sR.className   = 'nsd-right';
      var sP    = document.createElement('span'); sP.className   = 'nsd-price';
      sP.textContent = price ? '\u00a3' + parseInt(price).toLocaleString() : '';
      var sT    = document.createElement('span'); sT.className   = 'nsd-tier ' + tc;
      sT.textContent = tier.charAt(0).toUpperCase() + tier.slice(1);
      sR.appendChild(sP); sR.appendChild(sT);
      row.appendChild(sNum); row.appendChild(sR);
      (function(targetNum, targetCard) {
        row.addEventListener('click', function() {
          VIPNavClose();
          if (typeof resetAllFilters === 'function') resetAllFilters();
          if (typeof activeFilters !== 'undefined') activeFilters.search = targetNum;
          if (typeof applyFilters === 'function') applyFilters();
          setTimeout(function() {
            var el = document.getElementById('results-anchor') || document.getElementById('numGrid');
            if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
            var card = document.querySelector('#numGrid .num-card[data-num="' + targetNum + '"]');
            if (card) {
              setTimeout(function() {
                card.classList.add('card-highlight');
                setTimeout(function() { card.classList.remove('card-highlight'); }, 2000);
              }, 400);
            }
          }, 300);
        });
      })(num, card);
      dr.appendChild(row);
    }
    if (mMatch.length > MAX) {
      var va = document.createElement('div');
      va.className = 'nsd-viewall';
      va.textContent = 'View all ' + mMatch.length + ' available numbers \u2192';
      va.addEventListener('click', function() {
        VIPNavCloseUI();
        var el = document.getElementById('numGrid');
        if (el) { scrollToEl(el, 80); }
      });
      dr.appendChild(va);
    }
    dr.classList.add('open');
  }

  /* Pre-Order numbers - cached collection fetch for substring search */
  function renderPoResults(products) {
    var qd = q.replace(/\D/g, '');
    var pMatch = [];
    for (var i = 0; i < products.length; i++) {
      if (qd && (products[i].title || '').replace(/\D/g, '').indexOf(qd) > -1) pMatch.push(products[i]);
    }
    if (!pMatch.length) {
      if (!mMatch.length) {
        var empty = document.createElement('div');
        empty.className = 'nsd-empty';
        empty.textContent = 'No numbers found';
        dr.appendChild(empty);
        dr.classList.add('open');
      }
      return;
    }
    var t2 = document.createElement('div');
    t2.className = 'nsd-title';
    t2.textContent = 'Pre-Order Numbers (' + pMatch.length + ')';
    dr.appendChild(t2);
    var showP = Math.min(pMatch.length, MAX);
    for (var p = 0; p < showP; p++) {
      var prod = pMatch[p];
      var row2 = document.createElement('div'); row2.className = 'nsd-item';
      var sN2  = document.createElement('span'); sN2.className  = 'nsd-num'; sN2.textContent = prod.title;
      var sR2  = document.createElement('span'); sR2.className  = 'nsd-right';
      var sB   = document.createElement('span'); sB.className   = 'nsd-badge-po'; sB.textContent = 'Pre-Order';
      sR2.appendChild(sB); row2.appendChild(sN2); row2.appendChild(sR2);
      (function(product) {
        row2.addEventListener('click', function() {
          VIPNavClose();
          window.location.href = '/products/' + product.handle;
        });
      })(prod);
      dr.appendChild(row2);
    }
    if (pMatch.length > MAX) {
      var va2 = document.createElement('div'); va2.className = 'nsd-viewall';
      va2.textContent = 'View all pre-order matches \u2192';
      va2.addEventListener('click', function() {
        VIPNavCloseUI();
        window.location.href = '/collections/pre-order-numbers';
      });
      dr.appendChild(va2);
    }
    dr.classList.add('open');
  }

  if (VIPNavRender._poCache) {
    renderPoResults(VIPNavRender._poCache);
  } else {
    fetch('/collections/pre-order-numbers/products.json?limit=250')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (VIPNavRender._gen !== myGen) return;
        VIPNavRender._poCache = (data && data.products) || [];
        renderPoResults(VIPNavRender._poCache);
      })
      .catch(function() {
        if (VIPNavRender._gen !== myGen) return;
        if (!mMatch.length) {
          var empty = document.createElement('div');
          empty.className = 'nsd-empty';
          empty.textContent = 'No numbers found';
          dr.appendChild(empty);
          dr.classList.add('open');
        }
      });
  }
}
/* Close on ESC or outside click */
document.addEventListener('keydown', function(e){ if(e.key==='Escape') VIPNavClose(); });
document.addEventListener('click',   function(e){
  var ov = document.getElementById('navSearchOverlay');
  var dr = document.getElementById('navDropdown');
  var bn = document.querySelector('.nav-icon-btn');
  if (!ov || !ov.classList.contains('open')) return;
  /* v145 (28 Oct 2026): the number-search results panel (#vip-num-search-panel, created by
     assets/vip-number-search.js and appended to <body>) is part of the search interface.
     A click on a non-link area inside it must not close the search bar on its own. */
  var sp = document.getElementById('vip-num-search-panel');
  if (sp && sp.contains(e.target)) return;
  if (!ov.contains(e.target) && (!dr||!dr.contains(e.target)) && (!bn||!bn.contains(e.target))) VIPNavClose();
});



function submitNumberRequest() {
  var name    = document.getElementById('reqName').value.trim();
  var contact = document.getElementById('reqContact').value.trim();
  var number  = document.getElementById('reqNumber').value.trim();
  var notes   = document.getElementById('reqNotes').value.trim();
  if (!name || !contact || !number) {
    alert('Please fill in your name, contact details and ideal number format.');
    return;
  }
  var msg = 'Hi, I would like to request a VIP number.' +
    '\n\nName: ' + name +
    '\nContact: ' + contact +
    '\nIdeal Number: ' + number +
    (notes ? '\nNotes: ' + notes : '');
  window.open('https://wa.me/447555666555?text=' + encodeURIComponent(msg), '_blank');
}



function resetAllFilters() {
  activeFilters.search   = '';
  activeFilters.category = 'all';
  activeFilters.tier     = '';
  activeFilters.priceMin = 0;
  activeFilters.priceMax = 999999;
  activeFilters.sequence = '';
  activeFilters.seqType  = '';
  var mainInp = document.getElementById('mainSearchInput');
  if (mainInp) mainInp.value = '';
  var navInp = document.getElementById('navSearchInput');
  if (navInp) navInp.value = '';
  var pMin = document.querySelector('.price-min'); if (pMin) pMin.value = '';
  var pMax = document.querySelector('.price-max'); if (pMax) pMax.value = '';
  var sbOpts = document.querySelectorAll('.sb-opt');
  for (var i = 0; i < sbOpts.length; i++) sbOpts[i].classList.remove('active');
  for (var j = 0; j < sbOpts.length; j++) {
    if (sbOpts[j].textContent.trim().indexOf('All Numbers') === 0) {
      sbOpts[j].classList.add('active'); break;
    }
  }
  if (typeof applyFilters === 'function') applyFilters();
  setTimeout(function() {
    var el = document.getElementById('numGrid');
    if (el) { scrollToEl(el, 80); }
  }, 100);
}



(function(){
  var KEY='vip_rv',MAX=10;
  var COL={platinum:'#9c6fe4',diamond:'#4caf50',gold:'#c9a84c',silver:'#aaa',bronze:'#cd7f32','pre-order':'#c9a84c'};
  function getL(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return[];}}
  function saveL(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  /* v145 (28 Oct 2026): each entry also stores the product's real URL (its handle can contain
     hyphens, e.g. /products/0776-172-172-0), and clicking an entry opens that product page.
     It no longer filters the collection (the old behaviour only searched the current page and
     showed "Showing 0-0 of 0 numbers"). */
  function cleanUrl(h){
    if(!h)return '';
    try{var a=document.createElement('a');a.href=h;if(a.hostname&&a.hostname!==location.hostname)return '';h=a.pathname;}catch(e){return '';}
    var i=h.indexOf('/products/');
    return i>-1?h.slice(i):'';
  }
  function addRV(num,price,tier,url){
    if(!num)return;
    var a=getL().filter(function(x){return x.num!==num;});
    a.unshift({num:num,price:price||'',tier:tier||'',url:cleanUrl(url)});
    if(a.length>MAX)a=a.slice(0,MAX);
    saveL(a);renderRV();
  }
  window.clearRV=function(){saveL([]);renderRV();};
  function fmt(n){return n.replace(/(\d{5})(\d{3})(\d{3})/,'$1 $2 $3');}
  function digits(t){return String(t||'').replace(/[\s\-]/g,'');}
  function saveUrl(num,url){var a=getL();for(var i=0;i<a.length;i++){if(a[i].num===num){a[i].url=url;}}saveL(a);}
  function goTo(num,tier,url){
    var u=cleanUrl(url);
    if(u){window.location.assign(u);return;}
    /* Entry saved before v145 (no URL): look the number up with Shopify's product search and
       open the product whose title matches it exactly. Nothing on the current page is filtered.
       If Shopify confirms the number no longer exists (sold), the entry is removed from Recently
       Viewed and the customer goes to the full Available Numbers list - the same place sold
       product URLs already redirect to. On a network error the entry is kept. */
    var q=String(num).split('&')[0];
    var fallback='/collections/available-numbers';
    if(!window.fetch){window.location.assign(fallback);return;}
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10',{credentials:'same-origin'})
      .then(function(r){if(!r.ok)throw new Error('http');return r.json();})
      .then(function(d){
        var ps=d&&d.resources&&d.resources.results&&d.resources.results.products;
        if(!Array.isArray(ps)){window.location.assign(fallback);return;}
        for(var i=0;i<ps.length;i++){
          if(digits(ps[i].title)===num){var pu=cleanUrl(ps[i].url);if(pu){saveUrl(num,pu);window.location.assign(pu);return;}}
        }
        saveL(getL().filter(function(x){return x.num!==num;}));
        window.location.assign(fallback);
      })
      .catch(function(){window.location.assign(fallback);});
  }
  function renderRV(){
    var sec=document.getElementById('rvSection');
    var list=document.getElementById('rvList');
    if(!sec||!list)return;
    var arr=getL();
    if(!arr.length){sec.classList.remove('has-items');return;}
    sec.classList.add('has-items');
    list.innerHTML='';
    arr.forEach(function(item){
      var row=document.createElement('div');row.className='rv-item';
      var sN=document.createElement('span');sN.className='rv-num';sN.textContent=fmt(item.num);
      var sR=document.createElement('span');sR.className='rv-right';
      var sD=document.createElement('span');sD.className='rv-dot';sD.style.background=COL[item.tier]||'#aaa';
      var sP=document.createElement('span');sP.className='rv-price';sP.textContent=item.price?''+parseInt(item.price).toLocaleString():'';
      sR.appendChild(sD);sR.appendChild(sP);
      if(item.tier==='pre-order'){var sB=document.createElement('span');sB.className='rv-badge';sB.textContent='Pre-Order';sR.appendChild(sB);}
      row.appendChild(sN);row.appendChild(sR);
      (function(n,t,u){row.addEventListener('click',function(){goTo(n,t,u);});})(item.num,item.tier,item.url);
      list.appendChild(row);
    });
  }
  document.addEventListener('DOMContentLoaded',function(){
    renderRV();
    /* v146 (28 Oct 2026): one delegated listener on the document instead of listeners bound to
       #numGrid / #poGrid. vip-ajax-pagination.js replaces the whole <main> (including #numGrid)
       when the customer sorts, changes category or changes page without a full reload, which
       silently dropped the old grid listener, so clicks after those changes were not recorded. */
    document.addEventListener('click',function(e){
      var t=e.target; if(!t||!t.closest)return;
      var c=t.closest('#numGrid .num-card');
      if(c){var l=c.querySelector('a[href*="/products/"]');addRV(c.getAttribute('data-num')||'',c.getAttribute('data-price')||'',c.getAttribute('data-tier')||'',l?l.getAttribute('href'):'');return;}
      var pc=t.closest('#poGrid .po-card');
      if(pc){var ne=pc.querySelector('.po-num');var pe=pc.querySelector('.po-price');addRV(ne?ne.textContent.replace(/ /g,''):'',pe?pe.textContent.replace(/[^0-9]/g,''):'','pre-order',ne&&ne.getAttribute?ne.getAttribute('href'):'');}
    });
  });
})();

/* v145 (28 Oct 2026): collection counter after filters are cleared.
   paginateFiltered() (templates/collection.available-numbers.liquid) only rewrites
   #pgInfoTop / #pgInfoBottom while a filter is active, so after a filter was cleared the
   last filtered text (e.g. "Showing 0-0 of 0 numbers") stayed on screen. This wrapper
   remembers each counter's server-rendered text (real counts for the current collection,
   page and sort order) the first time it sees it, and puts it back whenever no filter is
   active. Filtering itself is unchanged. */
(function(){
  if (typeof window.paginateFiltered !== 'function' || window.paginateFiltered.__vipCounter) return;
  var orig = window.paginateFiltered;
  function remember(el){ if (el && !el.hasAttribute('data-vip-default')) el.setAttribute('data-vip-default', el.innerHTML); }
  function isFiltered(){
    if (typeof activeFilters === 'undefined' || !activeFilters) return false;
    var f = activeFilters;
    return !!(f.search || (f.category && f.category !== 'all') || f.tier || f.sequence || f.seqType || f.priceMin > 0 || f.priceMax < 999999);
  }
  var wrapped = function(){
    var t = document.getElementById('pgInfoTop'), b = document.getElementById('pgInfoBottom');
    remember(t); remember(b);
    var r = orig.apply(this, arguments);
    if (!isFiltered()) {
      if (t) t.innerHTML = t.getAttribute('data-vip-default');
      if (b) b.innerHTML = b.getAttribute('data-vip-default');
    }
    return r;
  };
  wrapped.__vipCounter = true;
  window.paginateFiltered = wrapped;
})();


/* v151 (2026-10-30): menu button accessibility + compact-header support */
(function(){
  var BP = 1239;
  function els(){ return { b: document.getElementById('hamburgerBtn'), n: document.getElementById('mobileNav') }; }
  function sync(){ var e = els(); if (!e.b || !e.n) return; e.b.setAttribute('aria-controls','mobileNav'); e.b.setAttribute('aria-expanded', e.n.className.indexOf('open') > -1 ? 'true' : 'false'); }
  document.addEventListener('click', function(ev){
    var t = ev.target; if (!t || !t.closest) return;
    if (t.closest('#hamburgerBtn') || t.closest('#mobileOverlay')) {
      /* move focus into the menu only when it was opened from the keyboard (click detail 0); mouse/touch opens leave nothing highlighted */
      var kb = (ev.detail === 0);
      setTimeout(function(){ sync(); var e = els(); if (kb && e.n && e.n.className.indexOf('open') > -1) { var a = e.n.querySelector('a'); if (a) a.focus(); } }, 0);
    }
  });
  document.addEventListener('keydown', function(ev){
    if (ev.key !== 'Escape') return; var e = els();
    if (e.n && e.n.className.indexOf('open') > -1 && typeof closeMobileNav === 'function') { closeMobileNav(); sync(); if (e.b) e.b.focus(); }
  });
  window.addEventListener('resize', function(){
    var e = els(); if (e.n && e.n.className.indexOf('open') > -1 && window.innerWidth > BP && typeof closeMobileNav === 'function') closeMobileNav(); sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
